export interface SponsorAd {
  id: string
  placement: string
  enabled?: boolean
  sortOrder?: number
  brand?: string
  weight?: number
  title?: string
  description?: string
  logoUrl?: string
  imageUrl: string
  /** YYYY-MM-DD HH:mm:ss in Beijing time (UTC+8). */
  expiresAt: string
  imageAlt?: string
  href?: string
  linkLabel?: string
  isMock?: boolean
}

export function sponsorExpiryTime(value: unknown): number | null {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)) return null
  const timestamp = Date.parse(`${value.replace(' ', 'T')}+08:00`)
  if (!Number.isFinite(timestamp)) return null
  return new Date(timestamp + 8 * 60 * 60 * 1000).toISOString().slice(0, 19).replace('T', ' ') === value ? timestamp : null
}

/** Priority affects order only; invalid weights use the default priority. */
export function sortSponsors(ads: readonly SponsorAd[]): SponsorAd[] {
  const weight = (ad: SponsorAd) => Number.isFinite(ad.weight) && ad.weight! > 0 ? ad.weight! : 1
  const order = (ad: SponsorAd) => Number.isFinite(ad.sortOrder) ? ad.sortOrder! : 0
  return [...ads].sort((a, b) => weight(b) - weight(a) || order(a) - order(b)
    || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0))
}

/** Select a placement in the browser, including ads reused from the page cache. */
export function selectSponsors(ads: readonly SponsorAd[], placement: string, now = Date.now()): SponsorAd[] {
  return sortSponsors(ads.filter(ad => ad.placement === placement && ad.enabled !== false
    && (sponsorExpiryTime(ad.expiresAt) ?? 0) > now))
}
